<template>
  <Transition mode="out-in">
    <div v-if="local_form && !local_form.loading" class="pb-4" :class="{ 'daform-kartela': isKartela, 'daform-kartela--fullscreen': isKartela && fullscreen, 'daform-kartela--side': isKartela && !fullscreen }">
      <div class="form-name" :class="{ 'daform-kartela-title': isKartela }">
        <a class="mt-2 text-red-500 is-small" :class="{ 'daform-kartela-back': isKartela && fullscreen }" @click.prevent="$emit('close')" v-if="closes_form">
          <i class="mr-1 fa-solid" :class="isKartela && fullscreen ? 'fa-arrow-left' : 'fa-times'"></i>
        </a>
        <span v-html="local_form.name"></span>
        <a
          v-if="allowFullscreen"
          class="daform-fullscreen-toggle"
          href=""
          :title="fullscreen ? 'Kthe në panel' : 'Hape fullscreen'"
          @click.prevent="$emit('toggle-fullscreen')"
        >
          <i class="fa-solid" :class="fullscreen ? 'fa-compress' : 'fa-expand'"></i>
        </a>
      </div>

      <nav v-if="isKartela && kartelaSections.length" class="daform-kartela-nav">
        <a
          v-for="section in kartelaSections"
          :key="section.id"
          href=""
          class="daform-kartela-nav-item"
          @click.prevent="scrollToSection(section.id)"
        >
          <i :class="section.icon"></i>
          <span>{{ section.label }}</span>
        </a>
      </nav>

      <template v-if="isKartela">
        <div
          v-for="section in kartelaSections"
          :id="'daform-section-' + section.id"
          :key="section.id"
          class="daform-kartela-card"
        >
          <div class="daform-kartela-card-head">
            <i :class="section.icon"></i>
            <span>{{ section.label }}</span>
          </div>
          <div class="daform-kartela-card-body">
            <div class="form-field daform-kartela-row" v-for="(field, idx) in section.fields" :key="(field.name || 'row') + idx">
              <div class="daform-kartela-row-inner" v-if="Array.isArray(field)">
                <template v-for="(subfield, idxx) in field">
                  <component v-if="isFieldVisible(subfield)" :key="subfield.name + '_' + idxx" :is="subfield.type" :fields="local_form.fields" :field="subfield" @syncField="syncField" @reset="reset"> </component>
                </template>
              </div>
              <component v-else-if="isFieldVisible(field)" :is="field.type" :field="field" :fields="local_form.fields" @syncField="syncField"> </component>
            </div>
          </div>
        </div>
      </template>

      <template v-else>
        <div class="form-field" v-for="(field, idx) in filteredFields" :key="field.name ? field.name + idx : idx">
          <div class="is-flex is-form is-justify-content-space-between is-flex-direction-row" v-if="Array.isArray(field)">
            <template v-for="(subfield, idxx) in field">
              <component v-if="isFieldVisible(subfield)" :key="subfield.name + '_' + idxx" :is="subfield.type" :fields="local_form.fields" :field="subfield" @syncField="syncField" @reset="reset"> </component>
            </template>
          </div>

          <component v-else-if="isFieldVisible(field)" :is="field.type" :field="field" :fields="local_form.fields" @syncField="syncField"> </component>
        </div>
      </template>

      <div v-if="submitError" class="mx-4 mt-2 p-2 text-red-900 bg-red-100 border border-red-300 rounded text-sm">
        <i class="mr-1 fa-solid fa-exclamation-triangle"></i>
        {{ submitError }}
      </div>

      <div class="flex items-center justify-between px-4 pt-2">
        <a class="mt-2 bg-orange-200 bg-blue-200 button is-small text-black-300" v-if="updated" @click.prevent="resetAll()"> <i class="mr-1 fa-solid fa-clock-rotate-left"></i> Rikthe te dhenat fillestare </a>
        <a class="mt-2 mr-2 text-white uppercase bg-red-500 button hover:text-red-900 is-small" @click.prevent="deleteEntity()" v-if="local_form.delete && canDelete" href="">
          <i class="mr-2 has-text-danger-light fa fa-trash"></i> Fshi
        </a>

        <a class="mt-2 mr-2 text-white uppercase bg-teal-600 button hover:text-teal-900 is-small" @click.prevent="exportLabelPdf()" v-if="local_form.export_label" href="">
          <i class="mr-2 has-text-white fa-solid fa-file-pdf"></i> Eksporto etiketën (PDF)
        </a>
        <LabelExportModal
          :open="showLabelModal"
          :loading="labelExportLoading"
          :export-context="labelExportContext"
          title="Eksporto etiketën (PDF)"
          @close="closeLabelModal"
          @confirm="confirmExportLabel"
        />

        <div class="form-submit-buttons flex items-center flex-wrap px-4 pt-2" v-if="isRequiredFilled">
          <template v-if="local_form.submit.length > 1">
            <button
              type="button"
              v-for="(submit_button, index) in local_form.submit"
              :key="index"
              class="mt-2 daform-submit-btn"
              :class="[submit_button.style, { 'is-loading': isSubmitting }]"
              :disabled="isSubmitting"
              @click.prevent="submitForm(form2Object(), submit_button)"
            >
              <i class="mr-1 fa-solid fa-check"></i>
              {{ isSubmitting ? "Duke ruajtur..." : submit_button.label.toUpperCase() }}
            </button>
          </template>
          <template v-else>
            <button
              type="button"
              class="mt-2 daform-submit-btn daform-submit-btn--create"
              :class="[local_form.submit.style, { 'is-loading': isSubmitting }]"
              :disabled="isSubmitting"
              @click.prevent="submitForm(form2Object(), true)"
            >
              <i class="mr-1 fa-solid fa-check"></i>
              {{ isSubmitting ? "Duke ruajtur..." : local_form.submit.label }}
            </button>
          </template>
        </div>
      </div>
      <div class="flex items-center justify-between p-2 mt-4 text-red-900 bg-orange-200 required-fields" v-if="!isRequiredFilled">
        <i class="mr-1 fa-solid fa-exclamation-triangle"></i>
        Kujdes! Plotesoni te gjitha fushat e detyrueshme
      </div>
    </div>
    <div v-else-if="local_form && local_form.loading">
      <div class="has-text-centered"><i class="fa-solid fa-spinner fa-spin"></i> Po ngarkohet...</div>
    </div>
  </Transition>
</template>

<script>
/*eslint no-mixed-spaces-and-tabs: ["error", "smart-tabs"]*/
import Api from "@/services/Api";
import ProductsServices from "@/services/Product";
import { financaTargetsFailureText } from "@/utils/financaSaveNotice";
import textField from "./fields/text.vue";
import iconField from "./fields/icon.vue";
import numberField from "./fields/number.vue";
import dateField from "./fields/date.vue";
import imageUrl from "./fields/imageUrl.vue";
import emailField from "./fields/email.vue";
import Button from "./fields/button.vue";
import checkboxField from "./fields/checkbox.vue";
import textareaField from "./fields/textarea.vue";
import datetime from "./fields/datetime.vue";
import selectField from "./fields/select.vue";
import treeSelect from "./fields/tree-select.vue";
import multiplexer from "./fields/multiplexer.vue";
import attributes from "./fields/attributes.vue";
import categoryAttributesConfig from "./fields/category-attributes-config.vue";
import webCategoriesReadonly from "./fields/web-categories-readonly.vue";
import compositeItems from "./fields/composite-items.vue";
import passwordField from "./fields/password.vue";
import imageUpload from "./fields/imageUpload.vue";
import actionButton from "./fields/action-button.vue";
import sectionHeader from "./fields/section-header.vue";
import LabelExportModal from "@/components/LabelExportModal.vue";
import moment from "moment";
import helpers from "@/helpers.js";
import permissionMixin from "@/mixins/permissions-mixin.js";

export default {
  mixins: [permissionMixin],
  components: {
    textField,
    iconField,
    numberField,
    dateField,
    imageUrl,
    emailField,
    Button,
    checkboxField,
    textareaField,
    selectField,
    treeSelect,
    multiplexer,
    attributes,
    categoryAttributesConfig,
    "web-categories-readonly": webCategoriesReadonly,
    "composite-items": compositeItems,
    datetime,
    passwordField,
    imageUpload,
    "action-button": actionButton,
    "section-header": sectionHeader,
    LabelExportModal,
  },
  data() {
    return {
      local_form: null,
      file_name: "",
      showLabelModal: false,
      labelExportLoading: false,
      localSubmitting: false,
      submitError: "",
      resyncFinancaLoading: false,
    };
  },
  computed: {
    canDelete() {
      const deleteConfig = this.local_form?.delete;
      if (!deleteConfig) return false;
      if (!deleteConfig.permission) return true;
      return this.am_allowed(deleteConfig.permission);
    },
    isSubmitting() {
      return !!(this.saving || this.localSubmitting);
    },
    // FIX 1: Computed property for the loop
    filteredFields() {
      if (!this.local_form || !this.local_form.fields) return [];
      return this.local_form.fields.filter((f) => (Array.isArray(f) ? f.length > 0 : true));
    },
    isKartela() {
      return this.local_form?.layout === "kartela";
    },
    allowFullscreen() {
      return this.allow_fullscreen === true || this.allow_fullscreen === "true" || this.isKartela;
    },
    kartelaSections() {
      const sections = [];
      let current = null;
      (this.filteredFields || []).forEach((field) => {
        if (!Array.isArray(field) && field?.type === "section-header") {
          current = {
            id: field.name || "section-" + sections.length,
            label: field.label || "",
            icon: field.icon || "fa-regular fa-folder",
            fields: [],
          };
          sections.push(current);
          return;
        }
        if (!current) {
          current = {
            id: "main",
            label: this.local_form?.name || "",
            icon: "fa-regular fa-file-lines",
            fields: [],
          };
          sections.push(current);
        }
        current.fields.push(field);
      });
      return sections;
    },
    updated() {
      var updated_form = false;
      if (!this.local_form?.fields) return false;
      this.local_form.fields.map((f) => {
        if (f.length) {
          f.map((ff) => {
            if (ff.updated) updated_form = true;
          });
        } else {
          if (f.updated) updated_form = true;
        }
      });
      return updated_form;
    },

    isRequiredFilled() {
      if (this.local_form?.skip_required_validation === true) {
        let extraOk = true;
        const extraRequired = ["barcode", "delisted_reason"];
        const checkExtra = (ff) => {
          if (!extraRequired.includes(ff.name) || !ff.required || ff.disabled === true) return;
          if (!this.isFieldVisible(ff)) return;
          if (ff.value === null || ff.value === undefined || String(ff.value).trim() === "") extraOk = false;
        };
        (this.local_form?.fields || []).forEach((f) => {
          if (Array.isArray(f)) f.forEach(checkExtra);
          else checkExtra(f);
        });
        return extraOk;
      }
      var valid = true;
      if (!this.local_form?.fields) return false;

      const checkField = (ff) => {
        if (ff?.type === "section-header") return;
        // Skip validation if the field is hidden or disabled (disabled fields keep their value but should not block submit)
        if (!this.isFieldVisible(ff)) return;
        if (ff.disabled === true) return;

        if (ff.type == "tree-select") {
          const opts = ff.selected_options || {};
          if (ff.required && Object.keys(opts).length === 0) valid = false;
        } else if (ff.type == "multiplexer") {
          if (ff.required) {
            if (ff.data.length == 0) valid = false;
            else {
              var at_least_one_not_empty = false;
              ff.data.map((d) => {
                if (d.value != "") at_least_one_not_empty = true;
              });
              valid = at_least_one_not_empty;
            }
          }
        } else if (ff.type == "attributes" && ff.options) {
          if (ff.require_all === true) {
            for (const k of Object.keys(ff.options)) {
              const root = ff.options[k].root;
              if (root && helpers.isAttributeRootValueEmpty(root)) valid = false;
            }
          }
        } else if (ff.type == "image-upload") {
          if (ff.required) {
            let hasImage = false;
            if (ff.value != null) {
              if (Array.isArray(ff.value)) hasImage = ff.value.length > 0;
              else if (typeof ff.value === "object" && (ff.value.hasAtLeastOneImage === true || (Array.isArray(ff.value.existing_images) && ff.value.existing_images.length > 0)))
                hasImage = true;
            }
            if (!hasImage) valid = false;
          }
        } else if (ff.unique) {
          if (ff.exists == 1) valid = false;
          // Allow 0 and false as valid values; only null/undefined/empty string count as missing
          if (ff.required && (ff.value === null || ff.value === undefined || ff.value === "")) valid = false;
        } else if (ff.required) {
          // Treat as empty only null, undefined, or "" (allow 0, false, etc.)
          const empty = ff.value === null || ff.value === undefined || ff.value === "";
          if (empty) valid = false;
        }
      };

      this.local_form.fields.map((f) => {
        if (Array.isArray(f)) {
          f.map((ff) => checkField(ff));
        } else {
          checkField(f);
        }
      });

      return valid;
    },
    labelExportContext() {
      if (!this.local_form) {
        return { product_guids: [], category_guid: null, related_entity: "products", include_descendants: false };
      }
      const guid = this.local_form.guid;
      try {
        const formGuid = this.form2Object()?.guid;
        return {
          product_guids: formGuid || guid ? [formGuid || guid] : [],
          category_guid: null,
          related_entity: "products",
          include_descendants: false,
        };
      } catch {
        return {
          product_guids: guid ? [guid] : [],
          category_guid: null,
          related_entity: "products",
          include_descendants: false,
        };
      }
    },
  },
  methods: {
    exportLabelPdf() {
      const formData = this.form2Object();
      const guid = formData.guid || this.local_form.guid;
      if (!guid) {
        if (this.$toast) this.$toast.error("Produkti nuk ka guid.");
        return;
      }
      this.showLabelModal = true;
    },
    closeLabelModal() {
      if (this.labelExportLoading) return;
      this.showLabelModal = false;
    },
    async confirmExportLabel({ per_page }) {
      const formData = this.form2Object();
      const guid = formData.guid || this.local_form.guid;
      if (!guid) {
        if (this.$toast) this.$toast.error("Produkti nuk ka guid.");
        return;
      }
      this.labelExportLoading = true;
      try {
        await ProductsServices.exportLabels({ product_guids: [guid], per_page });
        if (this.$toast) this.$toast.success("PDF i etiketave u shkarkua.");
        this.showLabelModal = false;
      } catch (e) {
        if (this.$toast) this.$toast.error(e?.message || "Nuk u shkarkua PDF i etiketave.");
      } finally {
        this.labelExportLoading = false;
      }
    },
    // Helper to check if a field is currently visible based on its 'vif' rules
    scrollToSection(id) {
      const el = document.getElementById("daform-section-" + id);
      if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
    },
    isFieldVisible(field) {
      if (!field || field.type === "section-header") return true;
      if (!field.vif || field.vif.length === 0) return true;

      let is_visible = true;
      field.vif.forEach((condition) => {
        let targetField = null;
        this.local_form.fields.forEach((row) => {
          if (Array.isArray(row)) {
            row.forEach((f) => {
              if (f.name == condition.field) targetField = f;
            });
          } else {
            if (row.name == condition.field) targetField = row;
          }
        });

        if (targetField) {
          if (condition.value !== undefined) {
            if (targetField.value != condition.value) is_visible = false;
          }
          if (condition.value_not !== undefined) {
            if (targetField.value == condition.value_not) is_visible = false;
          }
        }
      });
      return is_visible;
    },

    async submitForm(p, button_config) {
      if (this.isSubmitting) return;

      this.submitError = "";
      const uniqueConflicts = this.collectUniqueConflicts();
      if (uniqueConflicts.length) {
        this.submitError = uniqueConflicts.join(" ");
        if (this.$toast?.error) this.$toast.error(this.submitError);
        return;
      }

      let close_on_submit = typeof button_config === "object" ? button_config.close_on_submit : button_config;
      let reset_fields = typeof button_config === "object" ? button_config.reset_fields : null;

      const doReset = async () => {
        if (reset_fields && Array.isArray(reset_fields)) {
          this.resetSpecific(reset_fields);
          await this.refreshDependentFields(reset_fields);
        } else {
          this.resetAll();
          await this.refreshAllDependentFields();
        }
      };

      this.localSubmitting = true;
      this.$emit("submitted", p, close_on_submit, close_on_submit === false ? doReset : null, this.finishSubmit);
      this.$nextTick(() => {
        if (this.saving !== true) this.localSubmitting = false;
      });
    },
    finishSubmit() {
      this.localSubmitting = false;
    },
    collectUniqueConflicts() {
      const conflicts = [];
      const scan = (ff) => {
        if (!this.isFieldVisible(ff)) return;
        if (ff.unique !== undefined && Number(ff.exists) === 1) {
          conflicts.push((ff.label || ff.name) + " i vendosur është i zënë.");
        }
      };
      (this.local_form?.fields || []).forEach((f) => {
        if (Array.isArray(f)) f.forEach(scan);
        else scan(f);
      });
      return conflicts;
    },

    resetSpecific(fields_to_reset) {
      // We map over the fields to create a new structure
      this.local_form.fields = this.local_form.fields.map((row) => {
        // CASE 1: The row is an array of columns (e.g. [Code, Name, Model])
        if (Array.isArray(row)) {
          return row.map((field) => {
            if (fields_to_reset.includes(field.name)) {
              let newVal = "";
              if (field.type === "checkbox-field") newVal = 0;
              if (field.type === "tree-select") newVal = "";
              if (field.type === "image-upload") newVal = [];

              return {
                ...field,
                value: newVal,
                selected_options: {}, // Clear tree-select options too
              };
            }
            // If not resetting, return the original field
            return field;
          });
        }

        // CASE 2: The row is a single field object
        else {
          if (fields_to_reset.includes(row.name)) {
            let newVal = "";
            if (row.type === "checkbox-field") newVal = 0;
            if (row.type === "tree-select") newVal = "";
            if (row.type === "image-upload") newVal = [];

            return {
              ...row,
              value: newVal,
              selected_options: {},
            };
          }
          return row;
        }
      });

      // OPTIONAL: Force a toast to confirm it triggered (for debugging)
      // this.$toast.info("Fushat u pastruan");
    },

    /** Find all fields with depends_on + api_call and refresh them (used after resetAll) */
    async refreshAllDependentFields() {
      const fieldsToRefresh = [];
      this.local_form.fields.forEach((row) => {
        const items = Array.isArray(row) ? row : [row];
        items.forEach((f) => {
          if (f.depends_on && f.api_call) fieldsToRefresh.push(f.name);
        });
      });
      if (fieldsToRefresh.length) await this.refreshDependentFields(fieldsToRefresh);
    },

    /** After resetSpecific: re-fetch values for reset fields that have depends_on + api_call (e.g. code from product/next-code) */
    async refreshDependentFields(fields_to_reset) {
      const getTriggerValue = (triggerFieldName) => {
        let triggerValue = null;
        this.local_form.fields.forEach((row) => {
          const scan = (ff) => {
            if (ff.name === triggerFieldName) {
              if (ff.type === "tree-select" && ff.selected_options && Object.keys(ff.selected_options).length > 0) {
                triggerValue = Object.keys(ff.selected_options)[0];
              } else if (ff.value != null && ff.value !== "") {
                triggerValue = ff.value;
              }
            }
          };
          if (Array.isArray(row)) row.forEach(scan);
          else scan(row);
        });
        return triggerValue;
      };

      for (const row of this.local_form.fields) {
        const items = Array.isArray(row) ? row : [row];
        for (const field of items) {
          if (!fields_to_reset.includes(field.name) || !field.depends_on || !field.api_call) continue;
          const triggerValue = getTriggerValue(field.depends_on);
          if (triggerValue == null) continue;
          try {
            const r = await Api(true).post(field.api_call, { category_id: triggerValue });
            if (field.type === "text-field" && r.data && r.data.code != null) {
              this.local_form.fields = this.local_form.fields.map((rrow) => {
                if (Array.isArray(rrow)) {
                  return rrow.map((f) => (f.name === field.name ? { ...f, value: r.data.code } : f));
                }
                return rrow.name === field.name ? { ...rrow, value: r.data.code } : rrow;
              });
            } else if (field.type === "select-field" && r.data && r.data.manager != null) {
              this.local_form.fields = this.local_form.fields.map((rrow) => {
                if (Array.isArray(rrow)) {
                  return rrow.map((f) => (f.name === field.name ? { ...f, value: r.data.manager } : f));
                }
                return rrow.name === field.name ? { ...rrow, value: r.data.manager } : rrow;
              });
            }
          } catch (e) {
            console.error("refreshDependentFields", field.name, e);
          }
        }
      }
    },

    deleteEntity() {
      if (confirm(this.local_form.delete.text ?? "Jeni te sigurte?")) {
        Api(true)
          .post(this.local_form.delete.api, { guid: this.local_form.delete.guid })
          .then((r) => {
            this.$emit("deleted", r.data);
          });
      }
    },
    resetAll() {
      this.local_form = { ...this.form };
    },
    reset(fi) {
      var field = {};
      this.form.fields.map((f) => {
        if (f.length) {
          f.map((ff) => {
            if (ff.name == fi.name) field = ff;
          });
        } else {
          if (f.name == fi.name) field = f;
        }
      });
      this.local_form.fields = [
        ...this.local_form.fields.map((f) => {
          if (f.length) {
            f = [
              ...f.map((ff) => {
                if (ff.name == field.name) ff = { ...field };
                return ff;
              }),
            ];
          } else {
            if (f.name == field.name) f = { ...field };
          }
          return f;
        }),
      ];
    },
    form2Object() {
      var obj = {};
      this.local_form.fields.map((f) => {
        const processField = (ff) => {
          if (!ff || ff.type === "section-header") return;
          // After toggling Aksesor, the inactive category tree / attributes must not
          // keep sending the previous side's values.
          if (!this.isFieldVisible(ff) && (ff.name === "type_id" || ff.name === "accessory_id")) {
            obj[ff.name] = "EMPTY-STRING";
            return;
          }
          if (!this.isFieldVisible(ff) && (ff.name === "attributes" || ff.name === "attributes_accessories")) {
            // Omit the list so the backend does not treat [] as "delete all EAV".
            return;
          }
          if (!this.isFieldVisible(ff) && ff.name === "exclusive_accessories") {
            obj[ff.name] = [];
            return;
          }
          if (ff.type == "tree-select") {
            if (ff.mode == "single") {
              let vvvv = Object.keys(ff.selected_options || {});
              obj[ff.name] = vvvv.length == 1 ? vvvv[0] : "EMPTY-STRING";
            } else if (ff.mode == "multiple") {
              obj[ff.name] = Object.keys(ff.selected_options || {});
            }
          } else if (ff.type == "multiplexer") {
            obj[ff.name] = ff.data;
          } else if (ff.type == "datetime") {
            obj[ff.name] = moment(ff.value).format("DD/MM/YYYY HH:mm");
          } else if (ff.type == "attributes") {
            obj[ff.name + "_list"] = Object.keys(ff.options || {}).map((k) => ff.options[k]);
          } else if (ff.type == "composite-items") {
            obj["composite_items_list"] = (ff.data || [])
              .map((row) => ({
                component_product_guid:
                  row.component_product_guid || row.guid || row.component_code || null,
                quantity: row.quantity,
              }))
              .filter((row) => row.component_product_guid)
              .map((row) => ({
                component_product_guid: String(row.component_product_guid).trim(),
                quantity: row.quantity,
              }));
          } else if (ff.type == "category-attributes-config") {
            const val = ff.value && Array.isArray(ff.value) ? ff.value : [];
            obj[ff.name] = val.map((item) => ({
              attribute_id: item.attribute_id,
              is_required: !!item.is_required,
              is_label: !!item.is_label,
              for_label_title: !!item.for_label_title,
              sort_nr: item.sort_nr ?? 0,
              sort_nr_label: item.sort_nr_label ?? item.sort_nr ?? 0,
              web_sort_nr: item.web_sort_nr ?? item.sort_nr ?? 0,
              show_in_web: !!item.show_in_web,
              show_in_web_as_filter: !!item.show_in_web_as_filter,
              measuring_unit:
                item.measuring_unit !== undefined && item.measuring_unit !== null
                  ? item.measuring_unit
                  : null,
              input_type_override: item.input_type_override ?? null,
            }));
          } else if (ff.type == "image-upload") {
            obj[ff.name] = ff.value;
          } else if (ff.type == "action-button") {
            // UI-only trigger; nothing to serialize
          } else if (ff.type == "web-categories-readonly") {
            // Read-only; web_cat_1/2/3 are set from category path on backend
          } else {
            // For select-field: preserve 0 (isNaN(0) is false, +0 is 0). Empty string stays as-is for non-numeric options.
            const raw = ff.value != null && ff.value !== "" ? ff.value : "EMPTY-STRING";
            obj[ff.name] = isNaN(raw) ? ff.value : +ff.value;
          }
        };

        if (Array.isArray(f)) {
          f.map((ff) => processField(ff));
        } else {
          processField(f);
        }
      });
      return obj;
    },

    findFormField(name) {
      let found = null;
      (this.local_form?.fields || []).forEach((row) => {
        const items = Array.isArray(row) ? row : [row];
        items.forEach((ff) => {
          if (ff.name === name) found = ff;
        });
      });
      return found;
    },

    findCategoryInTree(nodes, guid, code) {
      if (!Array.isArray(nodes) || !nodes.length) return null;

      const walk = (list, pred) => {
        if (!Array.isArray(list)) return null;
        for (const node of list) {
          if (pred(node)) return node;
          const found = walk(node.children, pred);
          if (found) return found;
        }
        return null;
      };

      const guidStr = guid != null && String(guid).trim() !== "" ? String(guid).trim() : null;
      const codeStr = code != null && String(code).trim() !== "" ? String(code).trim() : null;

      if (guidStr) {
        const byGuid = walk(nodes, (n) => String(n.id) === guidStr || String(n.guid || "") === guidStr);
        if (byGuid) return byGuid;
      }
      if (codeStr) {
        return walk(nodes, (n) => {
          const nodeCode = String(n.code || "").trim();
          return nodeCode !== "" && nodeCode === codeStr;
        });
      }
      return null;
    },

    getTreeSelectSelection(field) {
      if (!field || field.type !== "tree-select") {
        return { guid: null, code: null, label: null };
      }
      const selected = field.selected_options || {};
      const guid = Object.keys(selected).find((k) => selected[k]) || Object.keys(selected)[0] || null;
      if (!guid) return { guid: null, code: null, label: null };
      const node = this.findCategoryInTree(field.options, guid, null);
      const nodeCode = node?.code != null ? String(node.code).trim() : "";
      return {
        guid,
        code: nodeCode || guid,
        label: selected[guid] || node?.label || node?.name || guid,
      };
    },

    mapFormFields(updater) {
      this.local_form.fields = this.local_form.fields.map((f) => {
        if (Array.isArray(f)) return f.map(updater);
        return updater(f);
      });
    },

    matchSupplierOptionByCode(options, code) {
      const needle = String(code || "").trim().toUpperCase();
      if (!needle || !Array.isArray(options)) return null;
      return options.find((s) => String(s.code || "").trim().toUpperCase() === needle) || null;
    },

    syncSupplierFromCode(code) {
      const supplierField = this.findFormField("supplier");
      if (!supplierField || supplierField.type !== "tree-select") return;
      const needle = String(code || "").trim();
      if (!needle) {
        if (!Object.keys(supplierField.selected_options || {}).length) return;
        this.mapFormFields((ff) => {
          if (ff.name !== "supplier") return ff;
          return { ...ff, value: "", selected_options: {} };
        });
        return;
      }
      const match = this.matchSupplierOptionByCode(supplierField.options, needle);
      if (!match) return;
      const currentId = Object.keys(supplierField.selected_options || {})[0];
      if (currentId != null && String(currentId) === String(match.id)) return;
      this.mapFormFields((ff) => {
        if (ff.name !== "supplier") return ff;
        return { ...ff, value: match.id, selected_options: { [match.id]: match.label } };
      });
    },

    syncSupplierCodeFromSelection(supplierField) {
      if (!this.findFormField("supplier_code")) return;
      const ids = Object.keys(supplierField.selected_options || {});
      const selectedId = ids.length === 1 ? ids[0] : null;
      let code = "";
      if (selectedId != null && Array.isArray(supplierField.options)) {
        const opt = supplierField.options.find((o) => String(o.id) === String(selectedId));
        code = opt?.code ? String(opt.code).trim().toUpperCase() : "";
      }
      this.mapFormFields((ff) => {
        if (ff.name !== "supplier_code") return ff;
        const current = String(ff.value || "").trim().toUpperCase();
        if (current === code) return ff;
        return { ...ff, value: code };
      });
    },

    async syncField(field) {
      if (field.type === "action-button" && field.action === "generate_barcode" && field._actionTrigger) {
        await this.handleGenerateBarcode();
        return;
      }
      if (field.type === "action-button" && field.action === "resync_financa" && field._actionTrigger) {
        await this.handleResyncFinanca();
        return;
      }

      var is_dependence = false;
      var dependence_data = [];
      var is_excluded = false;
      var excluded_fields = [];

      // 1. UPDATE FORM STATE & IDENTIFY DEPENDENCIES
      this.local_form.fields = [
        ...this.local_form.fields.map((f) => {
          // Helper to process logic for a single field definition (ff)
          const processFieldLogic = (ff) => {
            // Check for exclusions
            if (ff.excluded_options && ff.excluded_options.includes(field.name)) {
              is_excluded = true;
              excluded_fields.push(ff.name);
            }
            // Check for dependencies (depends_on)
            else if (ff.depends_on == field.name) {
              is_dependence = true;

              // Prepare the value to send to backend (ID vs Value)
              let triggerValue = field.value;
              if (field.type == "tree-select" && field.selected_options) {
                const keys = Object.keys(field.selected_options);
                if (keys.length > 0) triggerValue = keys[0];
              }

              dependence_data.push({
                field: ff.name, // Target field name (e.g. "code")
                type: ff.type, // Target field type (e.g. "text-field")
                factor: ff.depends_on, // Trigger field (e.g. "type_id")
                url: ff.api_call, // API URL
                selected_options: field.selected_options, // Keep existing structure for attributes
                category_id: triggerValue, // Add clean value for code generation
                // Pass product guid so category/attributes returns existing EAV values
                entity: this.local_form?.guid || null,
              });
            }

            // Check if field was updated compared to original form
            ff.updated = false;
            this.form.fields.map((fi) => {
              if (fi.length) {
                fi.map((ffi) => {
                  if (ffi.name == ff.name) {
                    if (ff.type == "tree-select") {
                      ff.updated = ff.selected_options != ffi.selected_options;
                    } else ff.updated = ff.value != ffi.value;
                  }
                });
              } else {
                if (fi.name == ff.name) {
                  if (ff.type == "tree-select") {
                    ff.updated = ff.selected_options != fi.selected_options;
                  } else ff.updated = ff.value != fi.value;
                }
              }
            });
            return ff;
          };

          // Apply logic to rows (arrays) or single objects
          if (f.length) {
            f = [
              ...f.map((ff) => {
                if (ff.name == field.name) ff = { ...field };
                // Product <-> accessory toggle must never get locked.
                if (ff.name === "is_accessory") {
                  ff = { ...ff, readonly: false, disabled: false };
                }
                return processFieldLogic(ff);
              }),
            ];
          } else {
            if (f.name == field.name) f = { ...field };
            if (f.name === "is_accessory") {
              f = { ...f, readonly: false, disabled: false };
            }
            f = processFieldLogic(f);
          }
          return f;
        }),
      ];

      // 1b. When "name" changes, auto-fill "description" with the same value (product create/edit)
      if (field.name === "name" && field.value != null) {
        this.local_form.fields = this.local_form.fields.map((f) => {
          if (Array.isArray(f)) {
            return f.map((ff) => (ff.name === "description" ? { ...ff, value: field.value } : ff));
          }
          return f.name === "description" ? { ...f, value: field.value } : f;
        });
      }

      // 1b2. Supplier code <-> Furnitori (exact code match fills the name dropdown)
      if (field.name === "supplier_code" && this.findFormField("supplier")) {
        this.syncSupplierFromCode(field.value);
      } else if (field.name === "supplier" && this.findFormField("supplier_code")) {
        this.syncSupplierCodeFromSelection(field);
      }

      // 1c. Offer price: when default_price or has_offer_price changes, sync price and readonly state
      if (field.name === "default_price" || field.name === "has_offer_price") {
        const getVal = (name) => {
          let v = null;
          this.local_form.fields.forEach((row) => {
            const items = Array.isArray(row) ? row : [row];
            items.forEach((ff) => {
              if (ff.name === name) v = ff.value;
            });
          });
          return v;
        };
        const defaultPrice = field.name === "default_price" ? field.value : getVal("default_price");
        const hasOffer = field.name === "has_offer_price" ? field.value : getVal("has_offer_price");
        const offerChecked = hasOffer === 1 || hasOffer === true || hasOffer === "1";
        this.local_form.fields = this.local_form.fields.map((f) => {
          if (Array.isArray(f)) {
            return f.map((ff) => {
              if (ff.name !== "price") return ff;
              return { ...ff, value: offerChecked ? ff.value : defaultPrice, readonly: !offerChecked, disabled: !offerChecked };
            });
          }
          if (f.name !== "price") return f;
          return { ...f, value: offerChecked ? f.value : defaultPrice, readonly: !offerChecked, disabled: !offerChecked };
        });
      }

      // 1d. Product <-> accessory: map category by shared guid/code, else leave target empty for manual pick
      if (field.name === "is_accessory") {
        const isAccessory = field.value === 1 || field.value === true || field.value === "1";
        const sourceName = isAccessory ? "type_id" : "accessory_id";
        const targetName = isAccessory ? "accessory_id" : "type_id";
        const clearNames = isAccessory
          ? ["attributes", "exclusive_accessories", "services"]
          : ["attributes_accessories"];

        const sourceField = this.findFormField(sourceName);
        const targetField = this.findFormField(targetName);
        const selection = this.getTreeSelectSelection(sourceField);
        const match = targetField
          ? this.findCategoryInTree(targetField.options, selection.guid, selection.code)
          : null;

        this.local_form.fields = this.local_form.fields.map((f) => {
          const patchField = (ff) => {
            if (clearNames.includes(ff.name)) {
              if (ff.type === "tree-select") {
                return { ...ff, value: "", selected_options: {} };
              }
              if (ff.type === "attributes") {
                return { ...ff, options: {}, data: [] };
              }
              return { ...ff, value: "" };
            }
            if (ff.name === targetName && ff.type === "tree-select") {
              if (match) {
                const id = match.id || match.guid;
                const label = match.label || match.name || id;
                return { ...ff, selected_options: { [id]: label } };
              }
              return { ...ff, value: "", selected_options: {} };
            }
            return ff;
          };
          return Array.isArray(f) ? f.map(patchField) : patchField(f);
        });

        if (match) {
          const mappedField = this.findFormField(targetName);
          if (mappedField) {
            await this.syncField(mappedField);
          }
        }
      }

      // 1d. Aktiv: extra completeness fields are required only when the product is active
      if (field.name === "status") {
        this.applyRequiredWhenActive(field.value);
      }

      // 1e. No barcode: clear and lock barcode field + generate button
      if (field.name === "no_barcode") {
        const noBarcode = field.value === 1 || field.value === true || field.value === "1";
        this.local_form.fields = this.local_form.fields.map((f) => {
          if (Array.isArray(f)) {
            return f.map((ff) => {
              if (ff.name === "barcode") {
                return { ...ff, value: noBarcode ? "" : ff.value, readonly: noBarcode, disabled: noBarcode, required: !noBarcode };
              }
              if (ff.name === "generate_barcode_btn") {
                return { ...ff, disabled: noBarcode };
              }
              return ff;
            });
          }
          if (f.name === "barcode") {
            return { ...f, value: noBarcode ? "" : f.value, readonly: noBarcode, disabled: noBarcode, required: !noBarcode };
          }
          if (f.name === "generate_barcode_btn") {
            return { ...f, disabled: noBarcode };
          }
          return f;
        });
      }

      // Legacy auto barcode checkbox (kept for backward compatibility if still present in old forms)
      if (field.name === "auto_generate_barcode") {
        const autoChecked = field.value === 1 || field.value === true || field.value === "1";
        const checkboxLocked = !!(field.readonly || field.disabled);

        if (autoChecked && !checkboxLocked) {
          const excludeGuid = this.local_form?.guid || null;
          await Api(true)
            .post("product/next-barcode", excludeGuid ? { exclude_guid: excludeGuid } : {})
            .then((r) => {
              const barcode = r.data?.barcode || "";
              this.local_form.fields = this.local_form.fields.map((f) => {
                if (Array.isArray(f)) {
                  return f.map((ff) => {
                    if (ff.name === "barcode") return { ...ff, value: barcode, readonly: true, disabled: true };
                    return ff;
                  });
                }
                if (f.name === "barcode") return { ...f, value: barcode, readonly: true, disabled: true };
                return f;
              });
            });
        } else if (!autoChecked && !checkboxLocked) {
          this.local_form.fields = this.local_form.fields.map((f) => {
            if (Array.isArray(f)) {
              return f.map((ff) => {
                if (ff.name === "barcode") return { ...ff, value: "", readonly: false, disabled: false };
                return ff;
              });
            }
            if (f.name === "barcode") return { ...f, value: "", readonly: false, disabled: false };
            return f;
          });
        }
      }

      // 2. HANDLE EXCLUDED OPTIONS (Existing Logic)
      if (is_excluded) {
        this.local_form.fields.map((f) => {
          const processExclusion = (ff) => {
            if (excluded_fields.includes(ff.name)) {
              if (!ff.all_options) ff.all_options = ff.options;
              if (ff.all_options) ff.options = ff.all_options;
              var selected_options = {};
              if (ff.excluded_options)
                ff.excluded_options.map((ef) => {
                  selected_options = { ...selected_options, ...this.getSelectedOptions(ef) };
                });
              if (Object.keys(selected_options).length > 0) {
                ff.options = ff.all_options.filter((o) => {
                  return !selected_options[o.id];
                });
                Object.keys(ff.selected_options).map((o) => {
                  if (selected_options[o]) {
                    delete ff.selected_options[o];
                  }
                });
              }
            }
          };

          if (f.length) {
            f.map((ff) => processExclusion(ff));
          } else {
            processExclusion(f);
          }
        });
      }

      // 3. HANDLE API DEPENDENCIES (New + Existing Logic)
      if (is_dependence) {
        for (var i = 0; i < dependence_data.length; i++) {
          await Api(true)
            .post(dependence_data[i].url, dependence_data[i])
            .then((r) => {
              // --- Update Text Field Value (e.g. Code) ---
              if (dependence_data[i].type == "text-field") {
                this.local_form.fields = this.local_form.fields.map((row) => {
                  if (Array.isArray(row)) {
                    return row.map((f) => {
                      if (f.name == dependence_data[i].field) return { ...f, value: r.data.code };
                      return f;
                    });
                  } else {
                    if (row.name == dependence_data[i].field) return { ...row, value: r.data.code };
                    return row;
                  }
                });
              }
              // --- Update Select Field Value (e.g. Manager from category, including null) ---
              else if (dependence_data[i].type == "select-field") {
                if (r.data && Object.prototype.hasOwnProperty.call(r.data, "manager")) {
                  this.local_form.fields = this.local_form.fields.map((row) => {
                    if (Array.isArray(row)) {
                      return row.map((f) => {
                        if (f.name == dependence_data[i].field) return { ...f, value: r.data.manager };
                        return f;
                      });
                    } else {
                      if (row.name == dependence_data[i].field) return { ...row, value: r.data.manager };
                      return row;
                    }
                  });
                }
              }
              // --- Update Options (Attributes) ---
              else if (dependence_data[i].type == "attributes" || Array.isArray(r.data)) {
                const categoryId = Object.keys(dependence_data[i].selected_options || {})[0];
                const rawAttrs = Array.isArray(r.data) ? r.data : [];
                let options = helpers.create_attributes_field(rawAttrs, categoryId);

                // Preserve in-progress values when reload returns empty (e.g. missing entity)
                const targetName = dependence_data[i].field;
                let prevOptions = null;
                let requireAll = false;
                let requiredWhenActive = false;
                this.local_form.fields.forEach((row) => {
                  const items = Array.isArray(row) ? row : [row];
                  items.forEach((ff) => {
                    if (ff.name !== targetName) return;
                    if (ff.options) prevOptions = ff.options;
                    if (ff.require_all) requireAll = true;
                    if (ff.requiredWhenActive) requiredWhenActive = true;
                  });
                });
                if (prevOptions) {
                  options = helpers.mergePreservedAttributeValues(options, prevOptions);
                }
                if (requireAll) {
                  helpers.markAllAttributesRequired(options, true);
                } else if (requiredWhenActive) {
                  helpers.markAllAttributesRequired(options, false);
                }

                this.local_form.fields = [
                  ...this.local_form.fields.map((f) => {
                    if (f.length) {
                      f = f.map((ff) => {
                        if (ff.name == dependence_data[i].field) ff = { ...ff, options: options };
                        return ff;
                      });
                    } else {
                      if (f.name == dependence_data[i].field) f = { ...f, options: options };
                    }
                    return f;
                  }),
                ];
              }
            })
            .catch((err) => {
              console.error("Failed to sync dependent field", dependence_data[i].field, err);
            });
        }
      }
    },
    isActiveStatusValue(value) {
      return value === 1 || value === true || value === "1";
    },
    applyRequiredWhenActive(statusValue) {
      if (!this.local_form?.fields) return;
      const isActive =
        statusValue === undefined
          ? this.isActiveStatusValue(this.getFieldByName("status")?.value)
          : this.isActiveStatusValue(statusValue);
      this.mapFormFields((ff) => {
        if (!ff.requiredWhenActive) return ff;
        const next = { ...ff, required: isActive };
        if (ff.type === "attributes") {
          next.require_all = isActive;
          if (ff.options) {
            next.options = helpers.markAllAttributesRequired(ff.options, isActive);
          }
        }
        return next;
      });
    },
    getFieldByName(name) {
      let found = null;
      if (!this.local_form?.fields) return null;
      this.local_form.fields.forEach((row) => {
        const items = Array.isArray(row) ? row : [row];
        items.forEach((ff) => {
          if (ff.name === name) found = ff;
        });
      });
      return found;
    },
    async handleGenerateBarcode() {
      const noBarcodeField = this.getFieldByName("no_barcode");
      const noBarcode =
        noBarcodeField &&
        (noBarcodeField.value === 1 || noBarcodeField.value === true || noBarcodeField.value === "1");
      if (noBarcode) return;

      const excludeGuid = this.local_form?.guid || null;
      try {
        const r = await Api(true).post("product/next-barcode", excludeGuid ? { exclude_guid: excludeGuid } : {});
        const barcode = r.data?.barcode || "";
        this.local_form.fields = this.local_form.fields.map((f) => {
          if (Array.isArray(f)) {
            return f.map((ff) => {
              if (ff.name === "barcode") return { ...ff, value: barcode, readonly: false, disabled: false };
              if (ff.name === "no_barcode") return { ...ff, value: 0 };
              return ff;
            });
          }
          if (f.name === "barcode") return { ...f, value: barcode, readonly: false, disabled: false };
          if (f.name === "no_barcode") return { ...f, value: 0 };
          return f;
        });
        if (this.$toast?.success) this.$toast.success("Barkodi u gjenerua.");
      } catch (e) {
        if (this.$toast?.error) {
          this.$toast.error(e?.response?.data?.message || "Nuk u gjenerua barkodi.");
        }
      }
    },
    async handleResyncFinanca() {
      const guid = this.local_form?.guid;
      if (!guid) {
        if (this.$toast?.error) this.$toast.error("Mungon GUID i produktit.");
        return;
      }
      if (this.resyncFinancaLoading) return;
      this.resyncFinancaLoading = true;
      try {
        const data = await ProductsServices.resyncFinanca({ guids: [guid], source: "product_form" });
        const fail = Number(data?.synced_failed || 0);
        if (fail > 0) {
          if (this.$toast?.error) this.$toast.error(financaTargetsFailureText(data?.failed_sync));
        } else if (this.$toast?.success) {
          this.$toast.success("U ruajt në Financa 1 dhe Financa 2.");
        }
      } catch (e) {
        if (this.$toast?.error) {
          this.$toast.error(e?.response?.data?.message || "Nuk u sinkronizua në Financa.");
        }
      } finally {
        this.resyncFinancaLoading = false;
      }
    },
    getSelectedOptions(field) {
      var selected_options = {};
      this.local_form.fields.map((f) => {
        if (f.length) {
          f.map((ff) => {
            if (ff.name == field) {
              if (ff.selected_options) selected_options = { ...selected_options, ...ff.selected_options };
            }
          });
        } else {
          if (f.name == field) {
            if (f.selected_options) selected_options = { ...selected_options, ...f.selected_options };
          }
        }
      });
      return selected_options;
    },
  },
  watch: {
    saving(val) {
      if (!val) this.localSubmitting = false;
    },
    form: {
      handler: function (val, oldVal) {
        if (val.loading || val.name != oldVal.name) {
          this.local_form = { ...val };
          this.$nextTick(() => this.applyRequiredWhenActive());
        }
      },
      deep: true,
    },
  },
  created() {
    setTimeout(() => {
      this.local_form = { ...this.form };
      this.applyRequiredWhenActive();
    }, 100);
  },
  props: ["form", "is_overflow", "closes_form", "saving", "allow_fullscreen", "fullscreen"],
};
</script>

<style>
.form-name {
  border-bottom: 1px solid #ccc;
  border-left: 1px solid #ccc;
  text-align: right;
  border-radius: 2px 2px 0 0;
  padding: 4px 10px;
  background-color: #fff;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.bg-success-button {
  background-color: rgb(100, 111, 155);
}
.bg-delete-button {
  background-color: #b58b8b;
}
.v-enter-active,
.v-leave-active {
  transition: opacity 0.5s ease;
}
.v-enter-from,
.v-leave-to {
  opacity: 0;
}
.overflow-relative {
  overflow-y: scroll;
  height: 100%;
  position: relative;
}
.form-field:nth-child(even) {
  background-color: #fafafa;
}
.form-field {
  border-left: 1px solid #bfd4dc;
  border-right: 1px solid #bfd4dc;
  border-bottom: 1px solid #bfd4dc;
  padding: 2px 10px;
}
.field {
  padding: 1px 2px;
}
.field .label {
  font-size: 10px !important;
  text-transform: uppercase;
  font-weight: 500;
  color: #4b7482;
}
.field .select,
select,
input {
  width: 100%;
}
.list-enter-active,
.list-leave-active {
  transition: all 0.5s ease;
}
.list-enter-from,
.list-leave-to {
  opacity: 0;
  transform: translateX(30px);
}
.required-fields {
  font-size: 12px;
  border-radius: 2px;
  padding: 4px 10px;
  margin: 0 10px;
}
.form-submit-buttons {
  gap: 8px;
}
.daform-submit-btn {
  display: inline-flex;
  align-items: center;
  border: none;
  border-radius: 4px;
  padding: 6px 12px;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.02em;
  color: #fff !important;
  cursor: pointer;
  opacity: 1 !important;
  text-transform: uppercase;
  line-height: 1.25;
}
.daform-submit-btn--create {
  background-color: #15803d !important;
}
.daform-submit-btn--stay {
  background-color: #1d4ed8 !important;
}
.daform-submit-btn--copy {
  background-color: #6d28d9 !important;
}
.daform-submit-btn:disabled {
  cursor: wait;
  opacity: 0.75 !important;
}

.daform-kartela {
  background: #f8fafc;
  padding: 12px 16px 32px;
  min-height: 100%;
}
.daform-kartela .form-name.daform-kartela-title {
  border: none;
  background: transparent;
  justify-content: flex-start;
  gap: 12px;
  text-align: left;
  padding: 8px 4px 16px;
  font-size: 20px;
  font-weight: 600;
  color: #0f172a;
}
.daform-fullscreen-toggle {
  margin-left: auto;
  color: #64748b;
  padding: 4px 8px;
}
.daform-fullscreen-toggle:hover {
  color: #0f172a;
}
.daform-kartela--side {
  padding: 4px 8px 16px;
  background: #fff;
}
.daform-kartela--side .form-name.daform-kartela-title {
  font-size: 15px;
  padding: 6px 4px 10px;
  border-bottom: 1px solid #e2e8f0;
  border-radius: 0;
}
.daform-kartela--side .daform-kartela-nav {
  gap: 4px;
  padding: 6px;
  margin-bottom: 10px;
}
.daform-kartela--side .daform-kartela-nav-item {
  font-size: 11px;
  padding: 4px 7px;
}
.daform-kartela--side .daform-kartela-card {
  margin-bottom: 10px;
}
.daform-kartela--side .daform-kartela-card-head {
  padding: 8px 12px;
  font-size: 13px;
}
.daform-kartela--side .daform-kartela-card-body {
  padding: 10px 12px 14px;
}
.daform-kartela--side .daform-kartela-row-inner {
  grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));
}
.daform-kartela--fullscreen {
  min-height: calc(100vh - 120px);
}
.daform-kartela-back {
  color: #64748b !important;
  margin-top: 0 !important;
}
.daform-kartela-nav {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin: 0 0 16px;
  padding: 8px;
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
}
.daform-kartela-nav-item {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 10px;
  border-radius: 8px;
  color: #475569;
  font-size: 12px;
  font-weight: 500;
  white-space: nowrap;
}
.daform-kartela-nav-item:hover {
  background: #f1f5f9;
  color: #0f172a;
}
.daform-kartela-card {
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  margin-bottom: 16px;
  overflow: hidden;
  scroll-margin-top: 12px;
}
.daform-kartela-card-head {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 16px;
  border-bottom: 1px solid #e2e8f0;
  font-size: 14px;
  font-weight: 600;
  color: #334155;
}
.daform-kartela-card-head i {
  color: #6366f1;
  width: 18px;
  text-align: center;
}
.daform-kartela-card-body {
  padding: 14px 16px 18px;
}
.daform-kartela .form-field,
.daform-kartela .form-field:nth-child(even) {
  background: transparent;
  border: none;
  padding: 6px 0;
}
.daform-kartela-row-inner {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 12px 16px;
  align-items: start;
}
.daform-kartela .field {
  min-width: 0;
  width: 100%;
}
.daform-kartela .field .label {
  font-size: 12px !important;
  font-weight: 600;
  text-transform: none;
  color: #334155;
}
.daform-kartela .checkbox-field .control {
  text-align: left !important;
}
.daform-kartela .multiplexer-field,
.daform-kartela .tree-select-field {
  grid-column: 1 / -1;
}
.daform-kartela .tree-select-trigger,
.daform-kartela .tree-select-dropdown {
  font-size: 13px;
}
.daform-kartela .tree-select-dropdown .is-flex.is-align-items-center {
  min-height: 38px;
  padding: 0 8px;
}
.daform-kartela .tree-select-row-text {
  font-size: 13px;
  font-weight: 500;
  color: #0f172a;
}
.daform-kartela .input,
.daform-kartela select,
.daform-kartela .select select {
  border-radius: 8px;
  min-height: 36px;
}
.daform-kartela .form-submit-buttons {
  justify-content: flex-end;
  padding: 8px 0 0;
}
</style>
